<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <div class="content-bottom-padded">
        <el-input
          v-model="category_name"
          placeholder="请输入分类名称"
          clearable
          style="width: 200px; margin-right: 12px"
        />
        <el-button type="primary" style="margin-right: 12px" @click="handleQuery">查询</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </div>
      <el-table v-loading="loading" :data="categoryList" style="width: 100%" row-key="category_id">
        <el-table-column prop="category_id" label="分类ID" width="100" />
        <el-table-column prop="category_name" label="分类名称" min-width="150" />
        <el-table-column label="创建时间" min-width="180">
          <template slot-scope="scope">
            <span v-if="getCreatedTime(scope.row)">{{ getCreatedTime(scope.row) | datetime }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleRelatedContent(scope.row)">管理内容</el-button>
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="content-top-padded"
        background
        layout="total, sizes, prev, pager, next"
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <router-view />

    <el-dialog
      :title="editForm.id ? '编辑分类' : '新增分类'"
      :visible.sync="editDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="resetEditForm"
    >
      <el-form
        ref="editFormRef"
        :model="editForm"
        :rules="editRules"
        label-width="80px"
      >
        <el-form-item label="分类" prop="category_name">
          <el-input
            v-model="editForm.category_name"
            placeholder="请输入分类"
            clearable
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmitEdit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getArticleCategoryList, saveArticleCategory, updateArticleCategoryInfo, deleteArticleCategoryInfo } from '@/api/article'

export default {
  data() {
    return {
      loading: false,
      category_name: '',
      categoryList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      editDialogVisible: false,
      editForm: {
        id: null,
        category_name: ''
      },
      editRules: {
        category_name: [
          { required: true, message: '请输入分类', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    refresh() {
      this.getCategoryList()
    },
    getCategoryList() {
      this.loading = true
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        category_name: this.category_name
      }
      getArticleCategoryList(params).then((response) => {
        const respData = (response && response.data) || {}
        const data = respData.data
        if (Array.isArray(data)) {
          this.categoryList = data
          this.total = Number(respData.total_count) || data.length
          return
        }
        const list = Array.isArray(data && data.list) ? data.list : []
        this.categoryList = list
        this.total = Number(data && data.total_count) || list.length
      }).finally(() => {
        this.loading = false
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.page = 1
      this.getCategoryList()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getCategoryList()
    },
    handleQuery() {
      this.page = 1
      this.getCategoryList()
    },
    getCreatedTime(row) {
      return row.created || row.create_time || row.created_at || ''
    },
    handleAdd() {
      this.editForm = { id: null, category_name: '' }
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },
    handleEdit(row) {
      this.editForm = {
        id: row.category_id,
        category_name: row.category_name || ''
      }
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },
    handleRelatedContent(row) {
      let detailPath = this.matchHidePage('detail')
      const segments = this.$route.path.split('/')
      const componentName = segments[segments.length - 1] || ''
      const duplicated = `${componentName}_${componentName}_detail`
      const expected = `${componentName}_detail`
      if (detailPath.indexOf(duplicated) !== -1) {
        detailPath = detailPath.replace(duplicated, expected)
      }
      const lastSlash = detailPath.lastIndexOf('/')
      const path = lastSlash >= 0 ? detailPath.slice(0, lastSlash + 1) + detailPath.slice(lastSlash + 1).toLowerCase() : detailPath
      this.$router.push({
        path,
        query: { category_id: row.category_id, category_name: row.category_name }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该分类吗？', '提示', {
        type: 'warning'
      }).then(() => {
        deleteArticleCategoryInfo(row.category_id).then(() => {
          this.$message.success('删除分类成功')
          this.getCategoryList()
        })
      }).catch(() => {})
    },
    handleSubmitEdit() {
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return
        const categoryName = (this.editForm.category_name || '').trim()
        if (this.editForm.id) {
          updateArticleCategoryInfo(this.editForm.id, {
            category_name: categoryName
          }).then(() => {
            this.$message.success('修改分类成功')
            this.editDialogVisible = false
            this.getCategoryList()
          })
          return
        }
        saveArticleCategory({
          category_name: categoryName
        }).then(() => {
          this.$message.success('新增分类成功')
          this.editDialogVisible = false
          this.page = 1
          this.getCategoryList()
        })
      })
    },
    resetEditForm() {
      this.editForm = { id: null, category_name: '' }
      this.$refs.editFormRef && this.$refs.editFormRef.resetFields()
    }
  },
  mounted() {
    this.getCategoryList()
  }
}
</script>

<style scoped lang="scss">
::v-deep .search-field-value {
  width: auto !important;
}
</style>
